export const MIN_DESKTOP_ITEM_WIDTH = 220;
export const MAX_DESKTOP_ITEM_WIDTH = 284;
export const MOBILE_ITEM_WIDTH = 284;
export const MOBILE_ICON_ITEM_WIDTH = 260;
export const MOBILE_RATING_ITEM_WIDTH = 180;
export const SPACE_BETWEEN_ITEMS = 4;
export const ARBITRARY_INITIAL_MOBILE_ITEMS_OFFSET = 52;
